/* Produktkarten: „+N" für weitere Farben – 7 O'CLOCK
   Angelegt: 2026-09-30

   Gilt in der Kollektionsübersicht und in Slidern mit der neuen Karte.
   Passen mobil nicht alle Farben in die Zeile, steht hinter der letzten ganz
   sichtbaren Farbe ein „+3" (Anzahl der weiteren Farben); die übrigen sind
   ausgeblendet. Tippen auf „+3" oder Wischen nach links zeigt die weiteren
   Farben; nach rechts über den Anfang hinaus geht es nicht (kein Gummiband),
   und die Zählung wird beim Scrollen nie neu berechnet.

   Ergänzung 01.10.2026: Kartentitel zweizeilig – „…, Green Silence" wird am letzten
   Komma geteilt, Kollektionsname („Green Silence") in Zeile 1, Produktname kleiner in
   Zeile 2. Linktext bleibt komplett (SEO). Ohne Komma bleibt der Titel wie er ist.

   Ladezeit 30.10.2026: Messen und Schreiben werden für alle Karten gesammelt und in EINEM Frame
   erledigt (erst alle Messungen, dann alle Änderungen). Vorher hat jede Karte einzeln gemessen
   und geschrieben – bei 40 Karten 40 erzwungene Layouts, ca. 4 s Rechenzeit auf dem Handy.
   Am Desktop (≥ 992 px) gibt es kein „+N", dort wird gar nicht gemessen.

   Styles: assets/custom-product-card.css
   Eingebunden über snippets/gtm-head.liquid. */
(function () {
  'use strict';

  var RESERVE = 30; // Platz für „+N" inkl. Abstand (px)
  var pending = new Set();
  var raf = false;

  function schedule(wrap) {
    pending.add(wrap);
    if (raf) return;
    raf = true;
    requestAnimationFrame(flush);
  }

  function flush() {
    raf = false;
    var list = Array.from(pending); pending.clear();
    var mobile = window.innerWidth < 992;
    var jobs = [];
    /* Phase 1: nur lesen */
    list.forEach(function (wrap) {
      var st = wrap.__ocState; if (!st || !wrap.isConnected) return;
      var swatches = wrap.querySelectorAll('.product-card-new_swatch');
      var sl0 = wrap.scrollLeft;
      var res = { wrap: wrap, st: st, n: swatches.length, show: false, moveIdx: -1, left: 0, top: 0, hidden: 0, atStart: sl0 <= 4 };
      if (mobile && swatches.length > 1) {
        var sl = sl0;
        var overflow = wrap.scrollWidth > wrap.clientWidth + 2;
        if (overflow) {
          var cs = getComputedStyle(wrap);
          var wr = wrap.getBoundingClientRect();
          var right = wr.right - (parseFloat(cs.paddingRight) || 0) + sl;
          var gap = parseFloat(getComputedStyle(swatches[0].parentElement).columnGap) || 14;
          var n = 0, rects = [];
          for (var i = 0; i < swatches.length; i++) {
            var r = swatches[i].getBoundingClientRect(); rects.push(r);
            if (r.right + sl + gap + RESERVE <= right) n = i + 1; else break;
          }
          if (n < 1) n = 1;
          if (n < swatches.length) {
            res.show = true; res.n = n;
            for (var m = n; m < swatches.length; m++) { if (swatches[m].classList.contains('is-active')) { res.moveIdx = m; break; } }
            var last = rects[n - 1], a = st.anchor.getBoundingClientRect();
            res.hidden = swatches.length - n;
            res.left = Math.round(last.left + sl + last.width + gap - a.left);
            res.top = Math.round(last.top - a.top);
          }
        }
      }
      jobs.push(res);
    });
    /* Phase 2: nur schreiben */
    jobs.forEach(function (res) {
      var st = res.st, wrap = res.wrap;
      if (res.show && res.moveIdx > -1) {
        var sw = wrap.querySelectorAll('.product-card-new_swatch');
        sw[res.moveIdx].parentElement.insertBefore(sw[res.moveIdx], sw[res.n - 1]);
      }
      st.n = res.n; st.show = res.show;
      if (res.show) {
        st.btn.textContent = '+' + res.hidden;
        st.btn.setAttribute('aria-label', res.hidden + ' weitere Farben anzeigen');
        st.btn.style.left = res.left + 'px';
        st.btn.style.top = res.top + 'px';
      }
      apply(wrap, res.atStart);
    });
  }

  /* Beim Scrollen nur ein-/ausblenden: am Anfang „+N" + versteckte Farben,
     weiter rechts alle Farben ohne „+N". Zählung bleibt unverändert. */
  function apply(wrap, atStartKnown) {
    var st = wrap.__ocState; if (!st) return;
    var atStart = typeof atStartKnown === 'boolean' ? atStartKnown : wrap.scrollLeft <= 4;
    var showNow = st.show && atStart;
    var swatches = wrap.querySelectorAll('.product-card-new_swatch');
    for (var k = 0; k < swatches.length; k++) {
      var want = showNow && k >= st.n;
      if (swatches[k].classList.contains('oc-swatch-hidden') !== want) swatches[k].classList.toggle('oc-swatch-hidden', want);
    }
    if (st.btn.classList.contains('is-visible') !== showNow) st.btn.classList.toggle('is-visible', showNow);
  }

  var observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(function (entries) {
    entries.forEach(function (entry) {
      var wrap = entry.target, st = wrap.__ocState; if (!st) return;
      var w = Math.round(entry.contentRect.width);
      if (w === st.lastW) return; /* nur bei echter Breitenänderung neu rechnen (kein erzwungenes Layout) */
      st.lastW = w;
      schedule(wrap);
    });
  }) : null;

  function setup(wrap) {
    if (wrap.__ocState) return;
    var card = wrap.closest('.product-card-new');
    // Im Kollektionsgrid ist die Karte display:contents -> Anker ist das Grid-Item,
    // in Slidern (z. B. „Weitere passende Produkte") die Karte selbst.
    var anchor = wrap.closest('.filter_product-list-item') || card;
    if (!anchor || !card) return;
    if (!anchor.style.position) anchor.style.position = 'relative'; /* ohne getComputedStyle (kein erzwungenes Layout) */

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'oc-swatch-more';
    btn.tabIndex = -1;
    anchor.appendChild(btn);

    var st = { n: 0, show: false, btn: btn, anchor: anchor, lastW: -1 };
    wrap.__ocState = st;
    wrap.__ocUpdate = function () { schedule(wrap); };

    wrap.addEventListener('scroll', function () { apply(wrap); }, { passive: true });
    // Farbwechsel (Alpine tauscht is-active) -> neu rechnen, falls am Anfang
    wrap.addEventListener('click', function () {
      setTimeout(function () { if (wrap.scrollLeft <= 4) schedule(wrap); else apply(wrap); }, 50);
    });
    // „+N": weitere Farben zeigen (Reihe nach rechts schieben)
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var target = wrap.scrollWidth - wrap.clientWidth;
      try { wrap.scrollTo({ left: target, behavior: 'smooth' }); } catch (err) { wrap.scrollLeft = target; }
      // Fallback für Browser ohne Smooth-Scroll bzw. wenn nichts passiert ist
      setTimeout(function () { if (wrap.scrollLeft < 4) wrap.scrollLeft = target; apply(wrap); }, 350);
    });
    btn.addEventListener('touchend', function (e) { e.stopPropagation(); }, { passive: true });
    if (observer) observer.observe(wrap); else schedule(wrap);
  }

  function splitTitle(link) {
    if (link.querySelector('.oc-card-title_coll')) return;
    var text = (link.textContent || '').trim();
    var i = text.lastIndexOf(',');
    if (i < 1 || i === text.length - 1) return;
    var coll = text.slice(i + 1).trim();
    var name = text.slice(0, i).trim();
    if (!coll || !name) return;
    var a = document.createElement('span'); a.className = 'oc-card-title_coll'; a.textContent = coll;
    var b = document.createElement('span'); b.className = 'oc-card-title_name'; b.textContent = name;
    link.textContent = '';
    link.appendChild(a);
    link.appendChild(document.createTextNode(' '));
    link.appendChild(b);
  }

  function scan() {
    var list = document.querySelectorAll('.product-card-new_swatches-wrap');
    for (var i = 0; i < list.length; i++) setup(list[i]);
    var links = document.querySelectorAll('.product-card-new_heading .product-card-new_heading-link');
    for (var k = 0; k < links.length; k++) splitTitle(links[k]);
  }

  scan();

  // Neue Karten (Filter, „Mehr laden") mitnehmen
  if (window.MutationObserver) {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        scan();
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  window.addEventListener('load', function () { scan(); });
  window.addEventListener('resize', function () { document.querySelectorAll('.product-card-new_swatches-wrap').forEach(function (w) { if (w.__ocState) schedule(w); }); }, { passive: true });
})();
